import { autoserialize } from 'cerialize';

export class TextDetectionResult {
  @autoserialize
  ocrDetectionType: string;

  @autoserialize
  cleanValue: string;

  @autoserialize
  detectedText: string;

  @autoserialize
  number: string;
}
